export var CatalogOrder;
(function (CatalogOrder) {
    CatalogOrder["Default"] = "default";
    CatalogOrder["Alphabetic"] = "alphabetic";
    CatalogOrder["Newest"] = "newest";
    CatalogOrder["MostSold"] = "mostSold";
    CatalogOrder["BestRated"] = "bestRated";
    CatalogOrder["MostRated"] = "mostRated";
    CatalogOrder["PriceLowToHigh"] = "priceLowToHigh";
    CatalogOrder["PriceHighToLow"] = "priceHighToLow";
})(CatalogOrder || (CatalogOrder = {}));
export class WcserviceClient {
    baseUrl;
    headers = {};
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    setLanguage(language) {
        this.headers['Accept-Language'] = language;
    }
    getHeaders(headers) {
        return Object.assign(this.headers, headers);
    }
    async findProducts(query) {
        const res = await fetch(`${this.baseUrl}/products/find`, {
            method: 'POST',
            headers: this.getHeaders({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(query ?? {}),
        });
        return await res.json();
    }
    async getProductCount(query) {
        const res = await fetch(`${this.baseUrl}/products/count`, {
            method: 'POST',
            headers: this.getHeaders({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(query ?? {}),
        });
        return (await res.json()).count ?? 0;
    }
    async getPriceRange(query) {
        const res = await fetch(`${this.baseUrl}/products/priceRange`, {
            method: 'POST',
            headers: this.getHeaders({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(query ?? {}),
        });
        return await res.json();
    }
    async findTaxonomyTerms(taxonomy, query) {
        const res = await fetch(`${this.baseUrl}/taxonomies/${taxonomy}/terms/find`, {
            method: 'POST',
            headers: this.getHeaders({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(query ?? {}),
        });
        return await res.json();
    }
    async findTaxonomyTermsHierarchically(taxonomy, query) {
        const res = await fetch(`${this.baseUrl}/taxonomies/${taxonomy}/terms/findHierarchical`, {
            method: 'POST',
            headers: this.getHeaders({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(query ?? {}),
        });
        return await res.json();
    }
}
